<script setup lang="ts">
import { computed } from 'vue';
import { buttonProps } from 'naive-ui';

const props = defineProps({
  ...buttonProps,
  /** Square edge length in px — 28 (row controls), 30 (back), 40 (header ⋯). */
  dimension: {
    type: Number,
    default: 34,
  },
});

// `dimension` is ours, not n-button's — keep it off the DOM element.
const passThrough = computed(() => {
  const { dimension, ...rest } = props;
  return rest;
});

const squareStyle = computed(() => ({
  width: `${props.dimension}px`,
  height: `${props.dimension}px`,
  padding: '0',
}));
</script>

<template>
  <!-- Square icon-only button from the CM mocks (back arrow, header ⋯, panel
       ＋). n-button has no square mode — only circle — so the dimensions are
       forced via style; everything else is the themed n-button. -->
  <n-button v-bind="passThrough" :style="squareStyle">
    <template #icon>
      <slot />
    </template>
  </n-button>
</template>
